"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onAuthFail = onAuthFail;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _routes = require("../../constants/routes");

var _redirects = require("../../domains/registration/auth/helpers/redirects");

// handler to axios response.interceptor error
function onAuthFail(_x) {
  return _onAuthFail.apply(this, arguments);
}

function _onAuthFail() {
  _onAuthFail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(error) {
    var _ref, originalReq, response;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = error || {}, originalReq = _ref.config, response = _ref.response; // If a 401 request occurs, redirect to sign in as it means the user is no longer authorized

            if (!(process.browser && (response === null || response === void 0 ? void 0 : response.status) === 401 && !(originalReq !== null && originalReq !== void 0 && originalReq.skipAuthInterceptor))) {
              _context.next = 5;
              break;
            }

            if (!(typeof window !== 'undefined')) {
              _context.next = 5;
              break;
            }

            window.location.href = (0, _redirects.getRedirectPathFromUrl)({
              url: _routes.SIGN_IN_ROUTE,
              context: {
                asPath: window.location.pathname
              }
            }); // Simulate in progress request
            // Prevents error while redirecting

            return _context.abrupt("return", new Promise(function () {}));

          case 5:
            throw error;

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _onAuthFail.apply(this, arguments);
}